import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts by Persona',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Persona',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Impacts',
                          points: {
                            '@': 'personaPoints',
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Persona',
                  yLabel: 'Count',
                },
              },
            ],
          },
          config: {
            '{}': {
              yAxis: {
                '{}': {
                  min: 0,
                  tickInterval: 1,
                  allowDecimals: false,
                },
              },
            },
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    personaPoints: {
      filter: {
        '>': [
          {
            '#': {
              '@': 'personaLinks',
            },
          },
          0,
        ],
      },
      sort: {
        by: {
          '#': {
            '@': 'personaLinks',
          },
        },
        descending: true,
      },
      target: 'ent:!personas:!persona',
      selection: {
        '{}': {
          x: {
            '@.': '!name',
          },
          y: {
            '#': {
              '@': 'personaLinks',
            },
          },
        },
      },
      subqueries: {
        personaLinks: {
          ref: {
            attr: 'attr:ent#!change_impact_personas#!change_impact_persona:!persona',
          },
          target: 'ent:!change_impact_personas:!change_impact_persona',
          selection: {
            '@.': '!id',
          },
        },
      },
    },
  },
}
